<template>
  <!--
          作者：luoyiming
          时间：2019-10-25
          描述：会员-用户列表
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form
        size="small"
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
      >
        <el-form-item label="昵称/手机号">
          <el-input
            v-model="formInline.nickName"
            placeholder="请输入昵称/手机号"
          ></el-input>
        </el-form-item>
        <!--        <el-form-item label="会员等级">
          <el-select v-model="formInline.gradeId" placeholder="请选择">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in gradeList" :key="index" :label="item.name" :value="item.gradeId">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="注册时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              v-model="formInline.startDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择开始日期"
            >
            </el-date-picker>
            <span>-</span>
            <el-date-picker
              v-model="formInline.endDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择结束日期"
            >
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="onSubmit"
          >查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            size="small"
            type="success"
            @click="onExport"
          >导出</el-button>
        </el-form-item>
      </el-form>
      <!-- <div class="mb16">
        <span>标签</span>
        <span class="pl10">
          <el-radio-group v-model="formInline.tagId" size="mini" @change="onSubmit">
            <el-radio-button label="0">全部</el-radio-button>
            <el-radio-button :label="item.tagId" v-for="(item, index) in allTag" :key="index" :value="item.tagId">
              {{ item.tagName }}
            </el-radio-button>
          </el-radio-group>
        </span>
      </div> -->
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table
          size="small"
          :data="tableData"
          border
          style="width: 100%"
          v-loading="loading"
        >
          <el-table-column
            prop="userId"
            label="ID"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="nickname"
            label="昵称"
          ></el-table-column>
          <el-table-column label="头像">
            <template slot-scope="scope">
              <!-- <img :src="scope.row.avatarurl" width="30px" height="30px" /> -->
              <img
                v-img-url="hasImages(scope.row.avatarurl)"
                alt=""
                width="50px"
              />
            </template>
          </el-table-column>
          <!-- <el-table-column prop="gradeName" label="会员等级"></el-table-column> -->
          <!-- <el-table-column prop="balance" label="余额"></el-table-column> -->
          <el-table-column
            prop="mobile"
            label="手机号"
          ></el-table-column>
          <el-table-column
            prop="inviteName"
            label="邀请人"
          ></el-table-column>
          <el-table-column
            prop="inviteGradeName"
            label="wifi上级等级"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            label="注册时间"
            width="140"
          ></el-table-column>
          <el-table-column
            prop="isLevel"
            label="是否可以调整下级等级"
            width="100"
          >
            <template #default="scope">
              <div
                style="display: inline-block;"
                @click="changeState(scope.row)"
              >
                <el-switch
                  v-model="scope.row.isLevel"
                  :active-value=1
                  :inactive-value=0
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="isCallback"
            label="是否允许回拨"
            width="100"
          >
            <template #default="scope">
              <div
                style="display: inline-block;"
                @click="isCallbackChangeState(scope.row)"
              >
                <el-switch
                  v-model="scope.row.isCallback"
                  :active-value=1
                  :inactive-value=0
                />
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="isTransferOption"
            label="是否可以调整划拨选项"
            width="100"
          >
            <template #default="scope">
              <div
                style="display: inline-block;"
                @click="isTransferOptionChangeState(scope.row)"
              >
                <el-switch
                  v-model="scope.row.isTransferOption"
                  :active-value=1
                  :inactive-value=0
                />
              </div>
            </template>
          </el-table-column> -->
          <el-table-column
            fixed="right"
            label="操作"
            width="280"
          >
            <template slot-scope="scope">
              <!-- <el-button @click="addClick(scope.row)" type="text" size="small" v-auth="'/user/user/recharge'">充值
              </el-button> -->
              <!-- <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/user/user/edit'">等级
              </el-button> -->
              <!-- <el-button @click="tagClick(scope.row)" type="text" size="small" v-auth="'/user/user/delete'">标签
              </el-button> -->
              <el-button
                @click="deleteClick(scope.row)"
                type="text"
                size="small"
                v-auth="'/user/user/delete'"
              >删除
              </el-button>
              <el-button
                @click="wifiSettingEditClick(scope.row)"
                type="text"
                size="small"
              >wifi分佣设置
              </el-button>
              <el-button
                @click="wifiEditClick(scope.row)"
                type="text"
                size="small"
              >wifi等级
              </el-button>
              <el-button
                @click="editClick(scope.row)"
                type="text"
                size="small"
                v-auth="'/user/user/edit'"
              >等级
              </el-button>
              <el-button
                @click="getCoupon(scope.row)"
                type="text"
                size="small"
                v-auth="'/user/user/edit'"
              >优惠券
              </el-button>
              <el-button
                @click="suspendOrOpenMember(scope.row)"
                type="text"
                size="small"
              >{{scope.row.memberType == 1 ? "暂停会员" : "开启会员"}}
              </el-button>
              <el-button
                @click="suspendOrOpenContribute(scope.row)"
                type="text"
                size="small"
              >{{scope.row.disbursementType == 1 ? "暂停出款" : "开启出款"}}
              </el-button>
              <el-button
                @click="addJd(scope.row)"
                type="text"
                size="small"
              >添加京东外卖商户
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <!--会员充值-->
    <Recharge
      v-if="open_add"
      :open_add="open_add"
      :form="userModel"
      :gradeList="gradeList"
      @closeDialog="closeDialogFunc($event, 'add')"
    ></Recharge>
    <!--会员等级-->
    <Grade
      v-if="open_edit"
      :open_edit="open_edit"
      :form="userModel"
      :gradeList="gradeList"
      :gradeAList="gradeAList"
      :gradeBList1="gradeBList1"
      :gradeBList2="gradeBList2"
      @closeDialog="closeDialogFunc($event, 'edit')"
    ></Grade>
    <!--wifi等级-->
    <WifiGrade
      v-if="wifiOpen_edit"
      :open_edit="wifiOpen_edit"
      :form="userModel"
      :gradeList="wifiGradeList"
      @closeDialog="closeDialogFunc($event, 'wifiEdit')"
    ></WifiGrade>
    <WifiSetting
      v-if="wifiSettingOpen_edit"
      :open_edit="wifiSettingOpen_edit"
      :form="userModel"
      @closeDialog="closeDialogFunc($event, 'wifiSettingEdit')"
    ></WifiSetting>
    <!--会员标签-->
    <Tag
      v-if="open_tag"
      :open_tag="open_tag"
      :form="userModel"
      @closeDialog="closeDialogFunc($event, 'tag')"
    ></Tag>
    <Coupon
      v-if="open_coupon"
      :open="open_coupon"
      :userid="userId"
      @closeDialog="closeDialogFunc($event, 'coupon')"
    ></Coupon>

    <!-- 京东外卖添加商户 -->
    <JdMerchant v-if="showMerchant" :userid="userId" @closeDialog="closeDialogFunc($event, 'merchant')" />
  </div>
</template>

<script>
import UserApi from '@/api/user.js';
import distributionApi from '@/api/plus/distribution.js';
import Grade from './dialog/Grade.vue';
import WifiGrade from './dialog/WifiGrade.vue';
import WifiSetting from './dialog/WifiSetting.vue';
import Recharge from './dialog/Recharge.vue';
import Coupon from './dialog/Coupon.vue';
import JdMerchant from './dialog/JdMerchant.vue';


import Tag from './dialog/Tag.vue';
import qs from "qs";
import { getCookie } from '@/utils/base.js';
export default {
  components: {
    /*编辑组件*/
    Grade,
    Recharge,
    Tag,
    WifiGrade,
    WifiSetting,
    Coupon,
    JdMerchant
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        nickName: '',
        gradeId: '',
        tagId: 0,
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      wifiOpen_edit: false,
      wifiSettingOpen_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      /*等级*/
      gradeList: [],
      /*等级A*/
      gradeAList: [
        {
          gradeId: 99,
          name: '无'
        }],
      /*等级B*/
      gradeBList1: [{
        gradeId: 0,
        name: '无'
      }],
      gradeBList2: [{
        gradeId: 0,
        name: '无'
      }
      ],
      /*wifi等级*/
      wifiGradeList: [{}],
      open_tag: false,
      /*所有标签*/
      allTag: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      open_coupon:false,
      userId:'',
      showMerchant:false
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
    this.getGradeList();
  },
  methods: {
    getGradeList() {
      UserApi.gradeAList(true)
        .then(res => {
          this.gradeAList = res.data
        })
        .catch(error => { });
      UserApi.gradeBList({
        version: 1
      })
        .then(res => {
          this.gradeBList1 = res.data
        })
        .catch(error => { });
      UserApi.gradeBList({
        version: 2
      })
        .then(res => {
          this.gradeBList2 = res.data
        })
        .catch(error => { });
      distributionApi.getWifiGrade().then(res => {
        this.wifiGradeList = res.data;
      }).catch(err => {
        console.log(err)
      })
    },
    hasImages(e) {
      if (e) {
        return e;
      } else {
        return '';
      }
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = self.formInline;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      UserApi.userlist(Params, true)
        .then(res => {
          self.loading = false;
          self.tableData = res.data.userList.records;
          self.totalDataNumber = res.data.userList.total;
          self.gradeList = res.data.gradeList;
          self.allTag = res.data.tagList;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*搜索查询*/
    onSubmit() {
      let self = this;
      self.loading = true;
      self.curPage = 1;
      self.getTableList();
    },

    /*打开添加*/
    addClick(item) {
      this.userModel = item;
      this.open_add = true;
    },
    // 优惠券弹窗
    getCoupon(item) {
      this.userId = item.userId;
      this.open_coupon = true;
    },

    addJd(item){
      this.userId = item.userId;
      this.showMerchant = true
    },

    /*打开编辑*/
    editClick(item) {
      this.userModel = item;
      this.open_edit = true;
    },
    wifiEditClick(item) {
      this.userModel = item;
      this.wifiOpen_edit = true;
    },
    wifiSettingEditClick(item) {
      this.userModel = item;
      this.wifiSettingOpen_edit = true;
    },

    tagClick(item) {
      this.userModel = item;
      this.open_tag = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'wifiEdit') {
        this.wifiOpen_edit = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'wifiSettingEdit') {
        this.wifiSettingOpen_edit = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'tag') {
        this.open_tag = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if(f=='coupon'){
        this.open_coupon = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if(f=='merchant'){
        this.showMerchant = e.openDialog
      }
    },

    /*删除用户*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          UserApi.deleteuser({
            userId: row.userId
          },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，用户删除成功',
                  type: 'success'
                });
                self.getTableList();
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {
          self.loading = false;
        });
    },

    changeState(row) {
      let self = this
      self.loading = true
      UserApi.changeLevel({
        userId: row.userId,
        isLevel: row.isLevel ? 1 : 0
      },
        true
      )
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.getTableList();
            self.$message({
              message: '操作成功',
              type: 'success'
            });
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
          self.getTableList();
        });
    },
    isCallbackChangeState(row) {
      let self = this
      self.loading = true
      UserApi.changeCallback({
        userId: row.userId,
        isCallback: row.isCallback ? 1 : 0
      },
        true
      )
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.getTableList();
            self.$message({
              message: '操作成功',
              type: 'success'
            });
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
          self.getTableList();
        });
    },
    isTransferOptionChangeState(row) {
      let self = this
      self.loading = true
      UserApi.changeTransferOption({
        userId: row.userId,
        isTransferOption: row.isTransferOption ? 1 : 0
      },
        true
      )
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.getTableList();
            self.$message({
              message: '操作成功',
              type: 'success'
            });
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
          self.getTableList();
        });
    },

    /*暂停or启用会员*/
    suspendOrOpenMember(row) {
      let memberType = row.memberType;
      let self = this;
      self
        .$confirm(memberType == '1' ? "确认暂停会员吗" : "确认启用会员吗", '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          UserApi.suspendOrOpenMemberApi({
            userId: row.userId,
            type: memberType == '1' ? '2' : '1'
          },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.getTableList();
                self.$message({
                  message: '恭喜你，操作成功',
                  type: 'success'
                });
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {
          self.loading = false;
        });
    },

    /*暂停or开启出款*/
    suspendOrOpenContribute(row) {
      let disbursementType = row.disbursementType;
      let self = this;
      self
        .$confirm(disbursementType == '1' ? "确认暂停出款吗" : "确认开启出款吗", '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          UserApi.suspendOrOpenContributeApi({
            userId: row.userId,
            type: disbursementType == '1' ? '2' : '1'
          },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.getTableList();
                self.$message({
                  message: '恭喜你，操作成功',
                  type: 'success'
                });
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {
          self.loading = false;
        });
    },

    onExport: function () {
      let self = this;
      let Params = self.formInline;
      Params.token = getCookie('token');
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/api/shop/user/user/export?' + qs.stringify(Params);
    },
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/user/user/index.vue